import { useEffect } from "react";
import { useDrag } from "react-dnd";
import { setDragging } from "./dragDrop";
import { UserChip } from "./UserChip";

// container: {group, name}
export function DraggableCard({ user, container }) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "OrderCard",
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  useEffect(() => {
    if (isDragging) {
      setDragging({user, container});
    }
  }, [isDragging, user, container]);

  return (
    <div style={{ position: "relative" }}>
      <div
        ref={drag}
        style={{
          opacity: isDragging ? 0.5 : 1,
          cursor: "move",
        }}
      >
        <UserChip user={user} />
      </div>
    </div>
  );
}
